<!-- 单点登录 -->
<template>
  <div>
    <login-dialog ref="loginDialog" @close="loginDialogClose" @clickOk='loginDialogOk' :options="customList"></login-dialog>
  </div>
</template>

<script>
import API from '@/apis/index.js';
import {onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter,useRoute} from "vue-router";
import {isEmpty} from "@/tools/utils";
import loginDialog from './login-dialog';
import {ref} from "vue";
export default {
  name: "sso",
  components:{
    loginDialog
  },
  setup(){
    const $router = useRouter();
    const store = useStore();
    let loginDialog = ref();
    let customList = ref([]);
    async function loginSystem(){
      try{
        store.commit('page/clear_tab');
        await getData();
        let menus = localStorage.getItem('USER_MENUS') ? JSON.parse(localStorage.getItem('USER_MENUS')) : [];
        if(!isEmpty(menus)){
          let firstPage = menus[0][0].children[0];
          store.commit('page/add_tab',{ icon: firstPage.icon, title: firstPage.title, group: '', name: firstPage.name, to: firstPage.to });
          localStorage.setItem("preRoute", JSON.stringify({name:firstPage.name, path:firstPage.to}));
          $router.push({name: firstPage.name});
        }
      }catch (e) {
        console.log(e,'e');
      }
    }
    function getData(){
      return new Promise((resolve, reject)=>{
        Promise.all([getMenu()]).then(()=>{
          return resolve();
        }).catch(()=>{
          return reject();
        })
      })
    }
    function getMenu(){
      return new Promise((resolve, reject)=>{
        API.getMenu().then((data)=>{
          store.commit('page/setRootMenus',data.data.data);
          store.commit('user/set-user-permission',data.data.data);
          resolve();
        }).catch((error)=>{
          store.dispatch("response/set-api-response", {...error,errorMessage:'获取菜单失败!'});
          reject({...error,errorMessage:'获取菜单失败!'})
        })
      })
    }
    /**
     * 选择分销商进行登录
     */
    function openDbDialog(){
      loginDialog.value.open();
    }
    function loginDialogClose(){
      $router.push({name: 'login'});
      store.commit('user/logout');
    }
    function loginDialogOk(tenantId){
      let userBase = JSON.parse(localStorage.getItem('userBase'));
      let companyObj = userBase.customer.find(item=>{
        return tenantId == item.tenant_id
      })
      Object.keys(companyObj).forEach(key=>{
        (key != 'customer') && (userBase[key] = companyObj[key])
      });
      localStorage.setItem('userBase',JSON.stringify(userBase));
      store.commit('user/login-success',userBase);
      loginSystem();
    }
    /**
     * 登录逻辑
     * 1.判断返回的html 时候携带登录信息
     *   是  进入系统
     * 2.判断 是否登录成功跳转
     *   是 刷新浏览器 重新获取html 并拿取用户信息
     *   否 跳转登录页面重新登录
     */
    function check_session_user(){
      try{
        // 本地环境启用
        let userBase = localStorage.getItem('userBase');
        if(userBase!=null){
          store.commit('page/setRootMenus',[]);
          store.commit('page/clear_tab');
          let menus = localStorage.getItem('USER_MENUS') ? JSON.parse(localStorage.getItem('USER_MENUS')) : [];
          if(!isEmpty(menus)){
            let firstPage = menus[0][0].children[0];
            store.commit('page/add_tab',{ icon: firstPage.icon, title: firstPage.title, group: '', name: firstPage.name, to: firstPage.to,path:firstPage.to});
            localStorage.setItem("preRoute", JSON.stringify({name:firstPage.name, path:firstPage.to}));
            $router.push({name: firstPage.name});
          }
        }else{
          $router.push({name: 'login'})
        }
      }catch (e) {
        console.log(e,'报错');
      }
    }
    onMounted(()=>{
      check_session_user()
    });
    return{
      customList,
      loginDialog,
      loginDialogClose,
      loginDialogOk
    }
  }
}
</script>
